import { SignIn } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";
import { BRAND_NAME } from "../lib/brand";
import { useRuntimeMode } from "../lib/runtime";

// Mirrors lib/auth.tsx's HAS_CLERK check — a cloud-mode build missing
// VITE_CLERK_PUBLISHABLE_KEY (misconfigured Pages build) must show the same
// "not configured" message instead of <SignIn> crashing with no ClerkProvider.
const HAS_CLERK = Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);

export default function SignInPage() {
  const mode = useRuntimeMode();
  // Local runtime has no Clerk. A stray /sign-in (old bookmark, afterSignOutUrl,
  // catch-all) must never surface the cloud login on the LAN box — the device
  // is already inside the trusted perimeter and pairing gates it. Send it on.
  if (mode === "local") return <Navigate to="/server" replace />;
  if (mode === "loading") return <div className="grain min-h-screen bg-ink" />;
  if (!HAS_CLERK) {
    return (
      <div className="pos min-h-screen grid place-items-center p-6 text-center text-sm text-gray-500">
        Auth no configurada: este build no tiene VITE_CLERK_PUBLISHABLE_KEY y el runtime no es local.
      </div>
    );
  }
  return (
    <div className="grain min-h-screen bg-ink flex items-center justify-center p-6">
      <div className="text-center">
        <p className="font-mono text-xs tracking-[0.4em] text-mango uppercase mb-2">{BRAND_NAME}</p>
        <h1 className="font-display font-black text-5xl text-paper mb-6">Acceso staff</h1>
        <SignIn afterSignInUrl="/admin" signUpUrl="/sign-up" />
      </div>
    </div>
  );
}
